import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Chip,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Link,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

const AiDrivenInsights = ({ insights }) => {
  const [expanded, setExpanded] = useState(
    insights.find((i) => i.expanded)?.id || false
  );

  const handleChange = (panelId) => (_, isExpanded) => {
    setExpanded(isExpanded ? panelId : false);
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <AutoAwesomeIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem' }}>
            AI-Driven Insights
          </Typography>
        </Box>

        <Box>
          {insights.map((insight) => (
            <Accordion
              key={insight.id}
              expanded={expanded === insight.id}
              onChange={handleChange(insight.id)}
              disableGutters
              elevation={0}
              sx={{
                '&:before': { display: 'none' },
                borderBottom: '1px solid',
                borderColor: 'divider',
                '&:last-of-type': { borderBottom: 'none' },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                sx={{ px: 0, minHeight: 48, '& .MuiAccordionSummary-content': { my: 1.5 } }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Typography sx={{ fontWeight: 600, fontSize: '0.875rem', color: 'text.primary' }}>
                    {insight.title}
                  </Typography>
                  {insight.severity && (
                    <Chip
                      label={insight.severity}
                      size="small"
                      sx={{
                        bgcolor: insight.severityColor,
                        color: '#fff',
                        fontWeight: 600,
                        fontSize: '0.6875rem',
                        height: 22,
                      }}
                    />
                  )}
                </Box>
              </AccordionSummary>
              <AccordionDetails sx={{ px: 0, pt: 0, pb: 2 }}>
                <Typography
                  variant="body2"
                  sx={{ color: 'text.secondary', fontSize: '0.8125rem', mb: 2, lineHeight: 1.6 }}
                >
                  {insight.description}
                </Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Link
                    href="#"
                    underline="none"
                    sx={{
                      color: '#399432',
                      fontSize: '0.8125rem',
                      fontWeight: 500,
                      cursor: 'pointer',
                      '&:hover': { textDecoration: 'underline' },
                    }}
                  >
                    {insight.recommendation}
                  </Link>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.8125rem' }}>
                      Asset: {insight.asset}
                    </Typography>
                    {/* <OpenInNewIcon sx={{ fontSize: 14, color: 'text.secondary' }} /> */}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default AiDrivenInsights;
